// ===== CONFIG =====
const CONFIG = {
    LINZ_API_KEY: 'f6ea8593e3f14f16b37c54a78e5f79b3',
    STORE_URL: 'https://certificateoftitle.nz',
    PRODUCTS: {
        record:      { variantId:'42338771468427', name:'Record of Title',    price:'$42.90', handle:'record-of-title-current-with-diagram' },
        guaranteed:  { variantId:'42344182284427', name:'Guaranteed Search',  price:'$45.90', handle:'record-of-title-guaranteed-search' },
        historical:  { variantId:'42344192278667', name:'Historical Title',   price:'$42.90', handle:'record-of-title-historical' },
        instruments: { variantId:'42382781186187', name:'Instruments',        price:'$39.90', handle:'instruments-document' },
        package:     { variantId:'42344216461451', name:'Diligence Package',  price:'$189.90', handle:'pre-purchase-diligence-package' },
        legal:       { variantId:'42344214659211', name:'Legal Owner Search', price:'$65.90', handle:'legal-owner-search' },
        survey:      { variantId:'42344210792587', name:'Survey Plans',       price:'$49.90', handle:'cadastral-survey-plan-title-sheet' },
        expert:      { variantId:'42344219377803', name:'Expert Advice',      price:'$129.00', handle:'expert-advice' }
    }
};
const LAYERS = { ADDRESSES:'123113', TITLES:'50804', PARCELS:'51571' };

// ===== STATE =====
let selectedAddress = null, currentTitleRef = null, currentLegalDesc = null;
let propertyMap = null, parcelLayer = null, currentMarker = null;
let selectedParcelLayer = null, searchTimeout = null;

// ===== LIVE COUNTER =====
function updateOrders() {
    const ordersCount = document.getElementById('ordersCount');
    if (!ordersCount) return;
    const h = new Date().getHours(), m = new Date().getMinutes();
    const max = 232;
    if (h < 6)  { ordersCount.textContent = '0'; return; }
    if (h >= 22){ ordersCount.textContent = max; return; }
    const progress = ((h - 6) * 60 + m) / (16 * 60);
    const count = Math.min(max, Math.max(0, Math.floor(progress * max) + Math.floor(Math.random()*8) - 4));
    ordersCount.textContent = count;
}
updateOrders(); setInterval(updateOrders, 60000);

// ===== ADDRESS SEARCH =====
const addrInput = document.getElementById('addressInput');
const dropdown  = document.getElementById('autocompleteDropdown');
const panel     = document.getElementById('propertyPanel');

// Detect if input looks like a title reference
function isTitleRef(q) {
    // Patterns: SA64D/927, CT 1A/123, NA123/456, 123456, SA123, WN12A/345
    return /^[A-Za-z]{1,3}\s?\d/i.test(q) || /^\d{4,}$/.test(q);
}

addrInput.addEventListener('input', function() {
    const q = this.value.trim();
    clearTimeout(searchTimeout);
    if (q.length < 2) { dropdown.classList.remove('show'); return; }
    if (isTitleRef(q)) {
        searchTimeout = setTimeout(() => searchTitleRef(q), 300);
    } else {
        if (q.length < 3) { dropdown.classList.remove('show'); return; }
        searchTimeout = setTimeout(() => searchAddr(q), 300);
    }
});
addrInput.addEventListener('focus', function() {
    if (dropdown.children.length && this.value.length >= 3) dropdown.classList.add('show');
});
document.addEventListener('click', e => {
    if (!e.target.closest('.search-input-wrapper')) dropdown.classList.remove('show');
});

async function searchAddr(query) {
    dropdown.innerHTML = '<div style="padding:16px;color:#999;text-align:center;font-size:13px">Searching...</div>';
    dropdown.classList.add('show');
    try {
        const normalizedQuery = query.replace(/\bcresent\b/ig, 'crescent');
        const terms = normalizedQuery
            .split(/[\s,]+/)
            .map(term => term.trim().replace(/'/g, "''"))
            .filter(term => term.length >= 2);
        const cql = terms.length
            ? terms.map(term => `(full_address_ascii ILIKE '%${term}%' OR full_address ILIKE '%${term}%')`).join(' AND ')
            : `full_address_ascii ILIKE '%${normalizedQuery.replace(/'/g, "''")}%'`;
        const url = `https://data.linz.govt.nz/services;key=${CONFIG.LINZ_API_KEY}/wfs/?service=WFS&version=2.0.0&request=GetFeature&typeNames=layer-${LAYERS.ADDRESSES}&outputFormat=application/json&count=8&CQL_FILTER=${encodeURIComponent(cql)}`;
        const res = await fetch(url);
        const data = await res.json();
        const addrs = data.features.map(f => ({
            address_id: f.properties.address_id,
            full_address: f.properties.full_address,
            territorial_authority: f.properties.territorial_authority,
            lng: f.geometry.coordinates[0], lat: f.geometry.coordinates[1]
        }));
        if (!addrs.length) {
            dropdown.innerHTML = '<div style="padding:16px;color:#999;text-align:center;font-size:13px">No addresses found</div>';
            return;
        }
        dropdown.innerHTML = addrs.map((a, i) => `
            <div class="autocomplete-item" onclick="selectAddr(${i})">
                <div class="address">${a.full_address}</div>
                <div class="locality">${a.territorial_authority || ''}</div>
            </div>`).join('');
        window.addrResults = addrs;
    } catch (e) {
        console.error(e);
        dropdown.innerHTML = '<div style="padding:16px;color:#e33;text-align:center;font-size:13px">Search error. Try again.</div>';
    }
}

// ===== TITLE REFERENCE SEARCH =====
async function searchTitleRef(query) {
    dropdown.innerHTML = '<div style="padding:16px;color:#999;text-align:center;font-size:13px">Searching titles...</div>';
    dropdown.classList.add('show');
    try {
        const escaped = query.replace(/'/g, "''").replace(/\s/g, '');
        const url = `https://data.linz.govt.nz/services;key=${CONFIG.LINZ_API_KEY}/wfs/?service=WFS&version=2.0.0&request=GetFeature&typeNames=layer-${LAYERS.TITLES}&outputFormat=application/json&count=8&CQL_FILTER=${encodeURIComponent(`title_no ILIKE '${escaped}%'`)}`;
        const res = await fetch(url);
        const data = await res.json();
        const titles = data.features.map(f => ({
            title_no: f.properties.title_no,
            type: f.properties.type || '',
            status: f.properties.status || '',
            survey: f.properties.survey_reference || '',
            geometry: f.geometry
        }));
        if (!titles.length) {
            dropdown.innerHTML = '<div style="padding:16px;color:#999;text-align:center;font-size:13px">No titles found. Try address search instead.</div>';
            return;
        }
        dropdown.innerHTML = titles.map((t, i) => `
            <div class="autocomplete-item" onclick="selectTitle(${i})">
                <div class="address" style="font-weight:600">📄 ${t.title_no}</div>
                <div class="locality">${t.type}${t.status ? ' — ' + t.status : ''}</div>
            </div>`).join('');
        window.titleResults = titles;
    } catch (e) {
        console.error(e);
        dropdown.innerHTML = '<div style="padding:16px;color:#e33;text-align:center;font-size:13px">Search error. Try again.</div>';
    }
}

function selectTitle(i) {
    const t = window.titleResults[i];
    addrInput.value = t.title_no;
    dropdown.classList.remove('show');
    currentTitleRef = t.title_no;

    // Find center of title geometry to show on map
    if (t.geometry) {
        let coords;
        if (t.geometry.type === 'MultiPolygon') {
            coords = t.geometry.coordinates[0][0];
        } else if (t.geometry.type === 'Polygon') {
            coords = t.geometry.coordinates[0];
        } else {
            coords = [t.geometry.coordinates];
        }
        // Calculate centroid
        let latSum = 0, lngSum = 0;
        coords.forEach(c => { lngSum += c[0]; latSum += c[1]; });
        const lat = latSum / coords.length;
        const lng = lngSum / coords.length;

        // Create a fake address object to show on map
        const fakeAddr = {
            full_address: t.title_no + ' (' + t.type + ')',
            territorial_authority: t.status,
            lat: lat,
            lng: lng
        };
        selectedAddress = fakeAddr;
        showPanel(fakeAddr);
    }

    // Store title ref
    try {
        localStorage.setItem('certnz_titleRef', t.title_no);
        localStorage.setItem('selectedTitleRef', t.title_no);
        localStorage.setItem('certnz_timestamp', Date.now().toString());
    } catch(e) {}
}

function selectAddr(i) {
    const a = window.addrResults[i];
    selectedAddress = a;
    addrInput.value = a.full_address;
    dropdown.classList.remove('show');
    showPanel(a);
}

document.getElementById('searchBtn').addEventListener('click', () => {
    if (selectedAddress) { showPanel(selectedAddress); return; }
    const q = addrInput.value.trim();
    if (isTitleRef(q)) {
        if (window.titleResults?.length) { selectTitle(0); return; }
        if (q.length >= 2) searchTitleRef(q).then(() => { if (window.titleResults?.length) selectTitle(0); });
    } else {
        if (window.addrResults?.length) { selectAddr(0); return; }
        if (q.length >= 3) searchAddr(q).then(() => { if (window.addrResults?.length) selectAddr(0); });
    }
});
addrInput.addEventListener('keypress', e => { if (e.key === 'Enter') document.getElementById('searchBtn').click(); });

// ===== PROPERTY PANEL =====
async function showPanel(addr) {
    panel.classList.add('show');
    document.getElementById('propAddress').textContent = addr.full_address;
    document.getElementById('propDistrict').textContent = addr.territorial_authority || '—';
    document.getElementById('titleRefValue').textContent = '...';
    document.getElementById('propArea').textContent = '—';
    document.getElementById('propType').textContent = '—';
    document.getElementById('propStatus').textContent = '—';
    document.getElementById('propLegal').textContent = '';
    document.getElementById('titleBadge').classList.remove('golden');

    if (!propertyMap) {
        propertyMap = L.map('propertyMap', { attributionControl:false, scrollWheelZoom:false }).setView([addr.lat, addr.lng], 18);
        
        // Create both tile layers
        const streetLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png');
        const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}');
        
        // Add street layer by default
        streetLayer.addTo(propertyMap);
        
        // Add toggle button
        const toggleControl = L.control({ position: 'topright' });
        toggleControl.onAdd = function() {
            const div = L.DomUtil.create('div', 'leaflet-control-custom');
            div.innerHTML = '<button id="mapToggle" style="background:#fff;border:2px solid #dae0e7;border-radius:10px;padding:6px 12px;font-size:13px;font-weight:600;cursor:pointer;transition:all 0.2s;box-shadow:0 1px 3px rgba(0,0,0,.08);display:flex;align-items:center;gap:6px;color:#1e2328;font-family:Inter,-apple-system,sans-serif;" onmouseover="this.style.borderColor=\'#2d7d6e\';this.style.boxShadow=\'0 2px 8px rgba(45,125,110,.18)\'" onmouseout="this.style.borderColor=\'#dae0e7\';this.style.boxShadow=\'0 1px 3px rgba(0,0,0,.08)\'"><span id="mapIcon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2d7d6e" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="3" x2="9" y2="21"/><line x1="15" y1="3" x2="15" y2="21"/></svg></span> <span id="mapLabel">Map</span></button>';
            
            L.DomEvent.disableClickPropagation(div);
            
            div.querySelector('#mapToggle').addEventListener('click', function() {
                const isSatellite = propertyMap.hasLayer(satelliteLayer);
                const button = this;
                const icon = button.querySelector('#mapIcon');
                const label = button.querySelector('#mapLabel');
                
                if (isSatellite) {
                    // Switch to street map
                    propertyMap.removeLayer(satelliteLayer);
                    propertyMap.addLayer(streetLayer);
                    icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2d7d6e" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="3" x2="9" y2="21"/><line x1="15" y1="3" x2="15" y2="21"/></svg>';
                    label.textContent = 'Map';
                } else {
                    // Switch to satellite
                    propertyMap.removeLayer(streetLayer);
                    propertyMap.addLayer(satelliteLayer);
                    icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2d7d6e" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10A15 15 0 0 1 12 2z"/></svg>';
                    label.textContent = 'Satellite';
                }
            });
            
            return div;
        };
        toggleControl.addTo(propertyMap);
        
        propertyMap.on('moveend', () => { if (propertyMap.getZoom() >= 16) loadParcels(); });
        propertyMap.on('zoomend', updateZoom);
    } else {
        propertyMap.setView([addr.lat, addr.lng], 18);
    }
    if (currentMarker) propertyMap.removeLayer(currentMarker);
    currentMarker = L.marker([addr.lat, addr.lng]).addTo(propertyMap);
    setTimeout(() => { propertyMap.invalidateSize(); loadParcels(); }, 100);
    panel.scrollIntoView({ behavior:'smooth', block:'center' });
}

function updateZoom() {
    const hint = document.getElementById('zoomHint');
    if (propertyMap.getZoom() < 16) {
        hint.classList.add('show');
        if (parcelLayer) { propertyMap.removeLayer(parcelLayer); parcelLayer = null; }
    } else hint.classList.remove('show');
}

async function loadParcels() {
    if (propertyMap.getZoom() < 16) { updateZoom(); return; }
    const b = propertyMap.getBounds();
    const bbox = `${b.getWest()},${b.getSouth()},${b.getEast()},${b.getNorth()}`;
    try {
        const url = `https://data.linz.govt.nz/services;key=${CONFIG.LINZ_API_KEY}/wfs/?service=WFS&version=2.0.0&request=GetFeature&typeNames=layer-${LAYERS.PARCELS}&outputFormat=application/json&count=200&bbox=${bbox},EPSG:4326`;
        const data = await (await fetch(url)).json();
        if (parcelLayer) propertyMap.removeLayer(parcelLayer);
        if (data.features) data.features.sort((a,b) => (parseFloat(b.properties.calc_area)||999999999) - (parseFloat(a.properties.calc_area)||999999999));
        parcelLayer = L.geoJSON(data, {
            style: f => {
                const a = parseFloat(f.properties.calc_area)||0;
                return a > 10000
                    ? { color:'#bbb', weight:1, fillColor:'#bbb', fillOpacity:.03 }
                    : { color:'#0a0a0a', weight:1.5, fillColor:'#0a0a0a', fillOpacity:.04 };
            },
            onEachFeature: (f, layer) => {
                layer.on('click', e => { L.DomEvent.stopPropagation(e); onParcel(f, layer); });
                layer.on('mouseover', () => layer.setStyle({ fillOpacity:.1, weight:2 }));
                layer.on('mouseout', () => {
                    if (layer !== selectedParcelLayer) {
                        const a = parseFloat(f.properties.calc_area)||0;
                        layer.setStyle(a > 10000 ? { color:'#bbb',weight:1,fillOpacity:.03 } : { color:'#0a0a0a',weight:1.5,fillOpacity:.04 });
                    }
                });
            }
        }).addTo(propertyMap);

        // FIX v2.3: Auto-select best parcel — prefer Primary with titles, skip Easements
        if (currentMarker && data.features.length) {
            const ll = currentMarker.getLatLng();
            let best = null, bestF = null;
            let fallbackBest = null, fallbackBestF = null;
            parcelLayer.eachLayer(l => {
                if (l.getBounds?.().contains(ll)) {
                    const props = l.feature?.properties;
                    const a = parseFloat(props?.calc_area)||0;
                    const isEasement = props?.parcel_intent === 'Easement' || props?.topology_type === 'Secondary';
                    const hasTitles = !!props?.titles;

                    if (!isEasement && hasTitles) {
                        // Primary parcel with direct title link = best candidate
                        if (!best || a < (parseFloat(bestF?.properties?.calc_area)||999999999)) {
                            best = l; bestF = l.feature;
                        }
                    } else if (!isEasement) {
                        // Primary parcel without title = second choice
                        if (!fallbackBest || a < (parseFloat(fallbackBestF?.properties?.calc_area)||999999999)) {
                            fallbackBest = l; fallbackBestF = l.feature;
                        }
                    }
                    // Easements are skipped entirely for auto-selection
                }
            });
            const finalLayer = best || fallbackBest;
            const finalFeature = bestF || fallbackBestF;
            if (finalFeature && finalLayer) onParcel(finalFeature, finalLayer);
        }
    } catch (e) { console.error(e); }
}

async function onParcel(feature, layer) {
    const p = feature.properties;
    const bounds = L.geoJSON(feature).getBounds();
    const center = bounds.getCenter();

    if (selectedParcelLayer) {
        const a = parseFloat(selectedParcelLayer.feature?.properties?.calc_area)||0;
        selectedParcelLayer.setStyle(a > 10000 ? { color:'#bbb',weight:1,fillOpacity:.03 } : { color:'#0a0a0a',weight:1.5,fillOpacity:.04 });
    }
    selectedParcelLayer = layer;
    layer.setStyle({ color:'#0066ff', weight:3, fillColor:'#0066ff', fillOpacity:.08 });
    document.getElementById('titleRefValue').textContent = '...';

    try {
        const addrUrl = `https://data.linz.govt.nz/services;key=${CONFIG.LINZ_API_KEY}/wfs/?service=WFS&version=2.0.0&request=GetFeature&typeNames=layer-${LAYERS.ADDRESSES}&outputFormat=application/json&count=1&bbox=${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()},EPSG:4326`;
        const addrData = await (await fetch(addrUrl)).json();
        if (addrData.features?.length) {
            const na = addrData.features[0].properties;
            document.getElementById('propAddress').textContent = na.full_address || selectedAddress?.full_address || 'Unknown';
            document.getElementById('propDistrict').textContent = na.territorial_authority || '—';
            addrInput.value = na.full_address || '';
        }
        // FIX v2.2: Use parcel's direct title link instead of BBOX query
        // BBOX was returning titles from neighboring properties (confirmed bug)
        // The parcels layer has a 'titles' field with accurate parcel-to-title mapping
        let titleInfo = null;
        if (p.titles) {
            const titleNos = p.titles.split(',').map(t => t.trim()).filter(Boolean);
            if (titleNos.length) {
                try {
                    const cql = titleNos.map(t => `'${t}'`).join(',');
                    const tUrl = `https://data.linz.govt.nz/services;key=${CONFIG.LINZ_API_KEY}/wfs/?service=WFS&version=2.0.0&request=GetFeature&typeNames=layer-${LAYERS.TITLES}&outputFormat=application/json&count=${titleNos.length}&CQL_FILTER=${encodeURIComponent(`title_no IN (${cql})`)}`;
                    const tData = await (await fetch(tUrl)).json();
                    const live = tData.features.filter(f => f.properties.status === 'LIVE');
                    const freehold = live.filter(f => f.properties.type === 'Freehold');
                    titleInfo = (freehold[0] || live[0] || tData.features[0])?.properties || null;
                } catch(e) {
                    // API failed but we still have the title number from parcel
                    titleInfo = { title_no: titleNos[0], type: p.parcel_intent || '', status: '' };
                }
            }
        }
        // Fallback: BBOX query only when parcel has no direct title link
        if (!titleInfo) {
            const titles = await findTitles(bounds);
            titleInfo = titles[0] || null;
        }
        currentTitleRef = titleInfo?.title_no || 'N/A';

        // Persist to localStorage so product pages can pre-fill
        try {
            const addr = document.getElementById('propAddress')?.textContent || '';
            if (addr && addr !== 'Loading...' && addr !== '—') {
                localStorage.setItem('certnz_address', addr);
                localStorage.setItem('selectedAddress', addr);
            }
            if (currentTitleRef && currentTitleRef !== 'N/A') {
                localStorage.setItem('certnz_titleRef', currentTitleRef);
                localStorage.setItem('certnz_address', addr);
                localStorage.setItem('selectedTitleRef', currentTitleRef);
            }
            if (currentLegalDesc) {
                localStorage.setItem('certnz_legalDesc', currentLegalDesc);
            }
            localStorage.setItem('certnz_timestamp', Date.now().toString());
        } catch(e) {}
        currentLegalDesc = p.appellation || null;
        document.getElementById('titleRefValue').textContent = currentTitleRef;
        document.getElementById('titleBadge').classList.toggle('golden', currentTitleRef && currentTitleRef !== 'N/A');

        let area = '—';
        if (p.calc_area) { const sqm = parseFloat(p.calc_area); area = sqm >= 10000 ? (sqm/10000).toFixed(2)+' ha' : sqm.toFixed(0)+' m²'; }
        document.getElementById('propArea').textContent = area;
        document.getElementById('propType').textContent = titleInfo?.type || p.parcel_intent || '—';
        document.getElementById('propStatus').textContent = titleInfo?.status || '—';
        document.getElementById('propLegal').textContent = p.appellation ? `Legal: ${p.appellation}` : '';
        if (currentMarker) currentMarker.setLatLng(center);
    } catch (e) {
        console.error(e);
        document.getElementById('titleRefValue').textContent = 'Error';
    }
}

async function findTitles(bounds) {
    const bbox = `${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()}`;
    const url = `https://data.linz.govt.nz/services;key=${CONFIG.LINZ_API_KEY}/wfs/?service=WFS&version=2.0.0&request=GetFeature&typeNames=layer-${LAYERS.TITLES}&outputFormat=application/json&count=10&bbox=${bbox},EPSG:4326`;
    const data = await (await fetch(url)).json();
    return data.features.map(f => f.properties);
}

// ===== ADD TO CART =====
function certnzAddToCart(productKey) {
    const prod = CONFIG.PRODUCTS[productKey];
    if (!prod || !prod.variantId) return;

    // Get address from property panel, fallback to search input, then localStorage
    let address = document.getElementById('propAddress')?.textContent || '';
    if (!address || address === '—' || address === 'Loading...' || address === 'Unknown') {
        address = document.getElementById('addressInput')?.value || '';
    }
    if (!address) {
        address = localStorage.getItem('certnz_address') || '';
    }
    const titleRef = currentTitleRef && currentTitleRef !== 'N/A' && currentTitleRef !== '...'
        ? currentTitleRef
        : (localStorage.getItem('certnz_titleRef') || localStorage.getItem('selectedTitleRef') || '');
    const legalDesc = currentLegalDesc || localStorage.getItem('certnz_legalDesc') || '';
    const manualLookup = (document.getElementById('manualLookupDetails')?.value || localStorage.getItem('certnz_manualLookup') || '').trim().slice(0, 220);

    const properties = {};
    if (address && address !== '—' && address !== 'Loading...') properties['Property Address'] = address;
    if (titleRef) properties['Title Reference'] = titleRef;
    if (legalDesc) properties['Legal Description'] = legalDesc;
    if (manualLookup) properties['Address Search Notes'] = manualLookup;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: prod.variantId,
            quantity: 1,
            properties: properties
        })
    })
    .then(r => r.json())
    .then(() => { window.location.href = '/cart'; })
    .catch(err => {
        console.error('Cart error:', err);
        // Fallback: GET redirect
        let url = '/cart/add?id=' + prod.variantId + '&quantity=1';
        if (address && address !== '—') url += '&properties[Property Address]=' + encodeURIComponent(address);
        if (titleRef) url += '&properties[Title Reference]=' + encodeURIComponent(titleRef);
        if (manualLookup) url += '&properties[Address Search Notes]=' + encodeURIComponent(manualLookup);
        window.location.href = url;
    });
}

// Product section buttons
document.querySelectorAll('.panel-card-btn').forEach(btn => {
    btn.addEventListener('click', function() {
        if (!currentTitleRef || currentTitleRef === 'N/A' || currentTitleRef === '...') {
            alert('Please select a property first by clicking on a parcel.');
            return;
        }
        certnzAddToCart(this.dataset.product);
    });
});

// Map panel "Buy Now" buttons — add to cart and go to cart
document.querySelectorAll('.panel-card-buy').forEach(btn => {
    btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!currentTitleRef || currentTitleRef === 'N/A' || currentTitleRef === '...') {
            const searchInput = document.getElementById('addressSearch');
            if (searchInput) {
                searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                searchInput.focus();
                searchInput.style.boxShadow = '0 0 0 3px rgba(4, 120, 87, 0.4)';
                searchInput.setAttribute('placeholder', '👆 Type a property address first...');
                setTimeout(() => {
                    searchInput.style.boxShadow = '';
                    searchInput.setAttribute('placeholder', 'Search property address...');
                }, 3000);
            }
            return;
        }
        certnzAddToCart(this.dataset.product);
    });
});

// ===== PRODUCTS SHOW ALL =====
function toggleAllProducts() {
    const more = document.getElementById('productsMore');
    const premium = document.getElementById('productsPremium');
    const btn = document.getElementById('showAllBtn');
    const arrow = document.getElementById('showAllArrow');
    const showing = more.classList.contains('show');
    more.classList.toggle('show');
    premium.classList.toggle('show');
    btn.innerHTML = showing ? 'Show all 8 products <span id="showAllArrow">↓</span>' : 'Show less <span id="showAllArrow">↑</span>';
}

// ===== QUIZ =====
function showQuizResult(el) {
    const result = el.dataset.result;
    document.getElementById('quizQuestions').style.display = 'none';
    const map = { standard:'quizResultStandard', guaranteed:'quizResultGuaranteed', instruments:'quizResultInstruments', historical:'quizResultHistorical', package:'quizResultPackage' };
    document.getElementById(map[result]).classList.add('show');
}
function resetQuiz() {
    document.getElementById('quizQuestions').style.display = 'block';
    document.querySelectorAll('.quiz-result').forEach(el => el.classList.remove('show'));
}

// ===== FAQ =====
function toggleFaq(el) {
    const item = el.parentElement;
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
}

// ===== SMOOTH SCROLL =====
document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
        e.preventDefault();
        const t = document.querySelector(this.getAttribute('href'));
        if (t) t.scrollIntoView({ behavior:'smooth', block:'start' });
    });
});

// ===== STICKY CTA (show after scrolling past hero) =====
if (window.innerWidth <= 768) {
    const sticky = document.getElementById('stickyCta');
    let stickyVisible = false;
    window.addEventListener('scroll', () => {
        const heroBottom = document.getElementById('hero').getBoundingClientRect().bottom;
        if (heroBottom < 0 && !stickyVisible) { sticky.style.display = 'block'; stickyVisible = true; }
        else if (heroBottom >= 0 && stickyVisible) { sticky.style.display = 'none'; stickyVisible = false; }
    }, { passive:true });
}

// ===== EXIT INTENT =====
let exitShown = false;
document.addEventListener('mouseout', e => {
    if (e.clientY < 5 && !exitShown && !sessionStorage.getItem('exitDismissed')) {
        document.getElementById('exitOverlay').classList.add('show');
        exitShown = true;
    }
});
function closeExit() {
    document.getElementById('exitOverlay').classList.remove('show');
    sessionStorage.setItem('exitDismissed', '1');
}
document.getElementById('exitOverlay').addEventListener('click', e => {
    if (e.target === e.currentTarget) closeExit();
});

console.log('🏠 Certificate of Title NZ V2 — CRO Optimized');
// v2.3 - BUGFIX: title lookup uses parcel.titles + auto-select skips Easements 2026-02-03
